module.exports = __webpack_public_path__ + "static/media/sport_car.d6ad3703.jpg";